import type { AppearanceComponent } from '@setplex/tria-api'
import type { ModuleStructure, StructureOrigin } from './index.h'

import { createEvent, createStore } from 'effector'

/*
 * Dynamic and lazy loading of modules components and its content
 */

export const initModule = createEvent<{ identifier: string }>()
export const leaveModule = createEvent<{ identifier: string }>()
export const loadModule = createEvent<{ identifier: string }>()

/**
 * Restore / replace module structure (cache, init).
 * May trigger initial rows load when structure is empty.
 */
export const setStructure = createEvent<{
  identifier: string
  structure: ModuleStructure | null
  structureOrigin?: StructureOrigin
}>()

/**
 * Atomically apply API/client rows + origin without re-triggering loadModule.
 */
export const applyModuleStructure = createEvent<{
  structure: ModuleStructure | null
  structureOrigin: StructureOrigin
}>()

export const resetStructure = createEvent()

// store with components structure of current module - "current page structure"
export const $structure = createStore<ModuleStructure | null>(null)
  .on(setStructure, (_, { structure }) => structure)
  .on(applyModuleStructure, (_, { structure }) => structure)
  .reset(resetStructure)

/** Backend API rows vs client default/fallback rows (Home) */
export const $structureOrigin = createStore<StructureOrigin>('backend')
  .on(setStructure, (_, { structureOrigin }) => structureOrigin ?? 'backend')
  .on(applyModuleStructure, (_, { structureOrigin }) => structureOrigin)
  .reset(resetStructure)

export type LoadQueueItem = {
  identifier: string
  component: AppearanceComponent
}

// queue to load content of banners / rows
export const $loadQueue = createStore<Array<LoadQueueItem>>([])

export const loadContent = createEvent<AppearanceComponent>()
